import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article13() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article14');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article12');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article13-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article13-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article13-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <div variants={textAnimate} className="mb-4 mb-sm-5">
              <h1 className="fs-xl f-lora-i mb-1">people</h1>
              <h1 className="fs-xxl mb-3">POWER</h1>
              <p className="f-lora-i lh-base mb-4 mb-sm-5" variants={textAnimate}>What do the Hebridean island of Eigg, the mainland’s most remote pub, an Art Deco picture house, a patch of woodland above Loch Ness and the Tarras Valley Nature Reserve down in the Borders have in common? They are all community owned - and examples of what can be done when people pull together.</p>
            </div>
            <img className="img-fluid mb-4"
              src={require("../../Images/article13-right-img1.jpg")}
            />
            <img className="img-fluid mb-4"
              src={require("../../Images/article13-right-img2.jpg")}
            />

            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>It’s an 18-mile hike across rough, unforgiving moorland, a two-day trudge broken by a night in a bare-bones bothy, or a choppy seven-mile sea crossing from Mallaig to get to the Knoydart peninsula. There’s no road in and, when you’re knee-deep in mud and midges in the country’s ‘last wilderness,’ what spurs you on? The pub: shining like an amber beer-bright beacon in the distance. If you live in this cut-off coastal community, the village pub is even more of a lifeline. So what happens when someone threatens to close it? </p>
                <p className="" variants={textAnimate}>Anyone who knows the history of Knoydart will realise that was never going to happen - not if the 110-strong community had anything to do with it. </p>
                <p className="" variants={textAnimate}>The people here have a long history of pulling together. Songs have been written about the ‘Seven Men of Knoydart,’ local heroes who, returning from the Second World War, tried to seize the land back from Knoydart’s pro-Nazi owner, Lord Brocket in 1948. That attempt might have failed, but 50 years later, Knoydart became one of the first places to pull off a community buyout. In 1999 they took charge of the 17,300-acre Knoydart Estate, wresting it from the hands of its absentee landlords, and set up the Knoydart Foundation. </p>
                
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>What they inherited was a rundown estate, unreliable power supply and dilapidated local housing. Now, over 20 years later, they provide low rental housing for residents, green energy through Knoydart Renewables, a bunkhouse for tourists and ranger service providing outdoor activities. They’ve also planted half a million trees. </p>
                <p className="" variants={textAnimate}>The Old Forge is a low-slung, whitewashed inn on the village of Inverie’s picturesque waterfront. The pub’s Belgian owner, Jean-Pierre Robinet was an absentee landlord of another kind, opening the pub for just six months of the year. Then in 2021 a For Sale sign appeared. </p>
                <p className="" variants={textAnimate}>“The pub is the lifeblood of this place, the epicentre of the community, it’s where everything - the music, the meetings, the magic happens.” Jackie Robertson, who owns luxury hideaway, the Knoydart Hide, explains. And she should know. She and her husband Ian ran The Old Forge for 20 years. </p>
                <p className="" variants={textAnimate}>The community rallied round, forming The Old Forge Community Benefit Society and started fundraising in order to buy the pub and stop it from being turned into a holiday home. With financial support from the </p>
              </div>
            </div>

            

          </div>

          <div className="" ref={secondContainer}>

            <div className="row mb-4">
              <div className="col-6">
                <img className="img-fluid"
                  src={require("../../Images/article13-right-img3.jpg")}
                />
              </div>
              <div className="col-6">
                <img className="img-fluid"
                  src={require("../../Images/article13-right-img4.jpg")}
                />
              </div>
            </div>
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>government, a community shareholder initiative and a crowdfunding campaign they did it. It was one of the fastest crowdfunding campaigns ever, reaching the target of £40,000 in just seven hours - one of the incentives, to buy a wooden brick carved with your name, forming part of the new custom-built bar. </p>
                <p className="" variants={textAnimate}>“The great thing about having it under the community’s control is that it will be open all year round,” Jackie continues. “It’s as much for the local community as the tourists.” </p>
                <p className="" variants={textAnimate}>“It’s also a real showcase of what you can do within a seven-mile radius. We’re only using Knoydart venison from the hills, where possible locally grown produce, beer from the micro-brewery. And the music is back. The glue that kept it together was always the live music. Music brings everyone together. It’s how it used to be - and as it should be.” </p>
                <p className="" variants={textAnimate}>Land Reform in Scotland is an ongoing issue, the Scottish Government supporting community ownership through the establishment of the Scottish Land Commission and the Scottish Land Fund, which provides financial support </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>for communities hoping to buy out often-absentee landowners. Today, around 212,000 hectares (roughly 524,000 acres) is now community owned. That’s almost three per cent of the land in Scotland.  </p>
                <p className="" variants={textAnimate}>The first community buyout took place in 1993 when the Assynt Crofters Trust bought the 22,000-acre North Assynt Estate in Sutherland. The island of Eigg is one of the highest profile community owned islands, purchased in 1997 and now run by the Isle of Eigg Heritage Trust. But it’s not the only one. The island of Gigha joined the club in 2002 and the island of Ulva in 2018. Community ownership can bring a host of advantages including economic recovery and growth, sustainable development but, above all, it means communities are in charge of their own futures. </p>
                <p className="" variants={textAnimate}>Down in Dumfriesshire the town of Langholm has been at the centre of one of the most ambitious land buyouts to date. The Langholm Initiative raised £4 million in a little over six months, with backers such as the John Muir Trust and the Woodland Trust, to buy 5,200 acres from the Buccleuch Estate and create the Tarras Valley Nature Reserve. </p>
              </div>
            </div>
            <img className="img-fluid mb-4"
              src={require("../../Images/article13-right-img5.jpg")}
            />
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>The project’s aim: to help local people, nature and the climate. The idea is to generate revenue and employment opportunities via nature-based tourism and eco-ventures such as glamping and guided walks, with other income strands from sustainable forestry and renewables initiatives. Nature recovery projects are also a key part of the vision, with peatland restoration helping to lock in carbon, along with the clearing of conifer plantations and increasing areas of native woodland. After a second fundraising push in 2022, they doubled the size of the reserve to 10,500 acres, which now encompasses a variety of habitats.  </p>
                <p className="" variants={textAnimate}>The grassroots campaign again shows what can be achieved when people work together. Langholm, a traditional textile town was in economic decline. Now with the land in community hands, there is the chance to create alternative employment and revitalise the area. </p>
                <p className="" variants={textAnimate}>Jenny Barlow the Estate Manager sums it up: “It’s been a total whirlwind few years with two epic community buyouts helped by thousands of people. It was humbling </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>to be part of and an incredible rollercoaster, but the hard work really started the minute the land transferred over. The focus now is shaping together as a community what comes next. Supporting wider community regeneration through eco-tourism is an important part of the plan and over the coming years we will be developing our visitor experience. </p>
                <p className="" variants={textAnimate}>We’re so proud to be leading one of the largest communityled nature restoration initiatives in the UK and we want to be an inspiring example of what can be achieved for people and planet when communities work together.”  </p>
                <p className="" variants={textAnimate}>It’s just the start of what will be a long journey. But if there’s one thing for sure, there are plenty of people going along for the ride. </p>
              </div>
            </div>
            
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <h5 className="" variants={textAnimate}>The Community Cinema </h5>
                <p className="" variants={textAnimate}>The pretty Perthshire town of Aberfeldy’s striking Art Deco cinema, The Birks, opened on 3rd July 1939. By the 1980s, however, the number of cinema-goers had fallen and the picture house closed its doors in 1982. Over the next few decades it had a stint as an amusement arcade but gradually fell into disrepair until, in 2005, it was put up for sale. The Friends of Birks Cinema stepped into action; the plan to buy the building and bring cinema back to the town as part of a community-run social enterprise.  </p>
                <p className="" variants={textAnimate}>A grant from the government’s Town Centre Regeneration Fund started the fundraising ball rolling. Aberfeldy-born actor Alan Cumming became their patron and, in 2012, after reaching the £1.8 million target, the refurbishment began. The Birks re-opened ten years ago, with a 104- seat auditorium and café-bar on two levels. Today, it is a community hub with an eclectic programme of live theatre, ballet and opera screenings and community events from acoustic music sessions to evening ‘Book and Film Blethers’. </p>
                <h5 className="" variants={textAnimate}>The Community Woodland </h5>
                <p className="" variants={textAnimate}>In 1998 the scattered rural community of Abriachan, in the hills above Loch Ness, came together to buy an area of pine and spruce plantation to keep it accessible for local people. Forming the Abriachan Forest Trust, over the next two decades they transformed the 540-hectare forest into a centre for outdoor activities and education, creating a 40km network of walking paths and mountain bike trails, building tree houses, Bronze Age huts and a Forest School, modelled on those in Scandinavia, to teach children about the natural world and inspire them to tackle climate change. They have planted over 200,000 native tree species, restored areas of wetland and peatland and have set up a community garden to teach gardening skills, promote the value of locally-grown, sustainable food and even put on cookery classes. </p>

              </div>
              <div className="col-sm-6 last12-right"> </div>
            </div>

          </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article13;
